import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import EligibilityReport from "../../CcpSchool/CcpSchoolAppsAndTesting/inc/EligibilityReport";

const DistrictEligibility = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>Eligibility</ModalDialogTitle>
      <DialogContent>
        <EligibilityReport schoolId={schoolId} />
      </DialogContent>
    </Dialog>
  );
};

export default DistrictEligibility;
